import { render, staticRenderFns } from "./UploadVideo_upbox.vue?vue&type=template&id=7ec9b7f8&scoped=true&lang=pug&"
import script from "./UploadVideo_upbox.vue?vue&type=script&lang=js&"
export * from "./UploadVideo_upbox.vue?vue&type=script&lang=js&"
import style0 from "./UploadVideo_upbox.vue?vue&type=style&index=0&id=7ec9b7f8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9b7f8",
  null
  
)

export default component.exports